import { Box } from '@betterment/samba-react';
import './NavigationProgress.css';

export function NavigationProgress({ isLoading }: { isLoading: boolean }) {
  return (
    <Box
      role="progressbar"
      aria-label="Page loading"
      aria-hidden={!isLoading}
      css={{
        position: 'fixed',
        display: 'block',
        top: 0,
        left: 0,
        zIndex: 9999,
        height: '3px',
        width: '100%',
        background: 'primitives.teal.50',
        opacity: isLoading ? 1 : 0,
        transition: isLoading ? 'none' : 'opacity 150ms 150ms ease-in',
        animation: isLoading
          ? 'navigationProgressLoad 300ms ease-out forwards, navigationProgressTrickle 30s 300ms ease-out forwards'
          : 'none',
      }}
    />
  );
}
